import React, { useState } from 'react';
import { connect } from 'react-redux';
import theme from "theme.js";
import S from 'StyledBetSlipDetails.js';
import { getBetSlipCheckResults, clearBetSlipCheckResults, toggleBetSlipDetailsModal } from 'betSlipCheckActions.js';
import Box from "react-styled-box";
import { translation } from "helpers/utilsHelper.js";
import betSlipTypes from 'betSlipTypes.enum.js';
import _map from 'lodash/map';
import Loader from 'Loader.js';
import _isEmpty from 'lodash/isEmpty';

import { formatDateFromUnix, formatDate } from 'helpers/datesHelper.js';

const renderInformationData = (
    flexSize,
    translateDescription,
    value
) => {
    return (
        <S.InformationCellWrapper
            as={Box}
            alignItems="center"
            flexDirection="column"
            flex={flexSize}
        >
            <S.InformationTitle>{translation(`betSlipDetails_${translateDescription}`)}</S.InformationTitle>
            <S.InformationData
                as={Box}
                alignItems="center"
                justifyContent="center"
            >
                {value}
            </S.InformationData>
        </S.InformationCellWrapper>
    );
};

const renderBetSlipDetailsList = (
    transactionDetails
) => {


    return (
        <S.BetSlipDetailsListWrapper>
            <S.BetSlipDetailsListHeader
                as={Box}
                alignItems="center"
                flexDirection="row"
            >
                <S.Date>{translation(`betSlipDetails_date`)}</S.Date>
                <S.Event>{translation(`betSlipDetails_event`)}</S.Event>
                <S.Result>{translation(`betSlipDetails_result`)}</S.Result>
                <S.Odds>{translation(`betSlipDetails_odds`)}</S.Odds>
                <S.Score>{translation(`betSlipDetails_score`)}</S.Score>
                <S.Status>{translation(`betSlipDetails_status`)}</S.Status>
            </S.BetSlipDetailsListHeader>

            {_map(transactionDetails, ((transaction, index) => {

                const { eventName, gameName, outcomeName, outcomeResult, odds, score, eventStart, statusCode, eventId, gameId } = transaction;
                const transactionDetailClass = getTransactionStatus(statusCode, true);
                const transactionDetailTranslation = translation(getTransactionStatus(statusCode));

                return (
                    <S.BetSlipDetailEvent
                        as={Box}
                        alignItems="center"
                        flexDirection="row"
                        key={`${eventId}_${gameId}`}
                    >
                        <S.EventDateField>{formatDate(eventStart, 'dd-MM-yyyy')}&nbsp;{formatDateFromUnix(eventStart, 'HH:mm')}</S.EventDateField>
                        <S.EventNameField>
                            <S.EventName>{eventName}</S.EventName>
                            <S.EventGame>{gameName}</S.EventGame>
                            <S.EventOutcome>{outcomeName}</S.EventOutcome>
                        </S.EventNameField>
                        <S.EventResultField>{outcomeResult ? outcomeResult : '?'}</S.EventResultField>
                        <S.EventOddsField>{odds}</S.EventOddsField>
                        <S.EventScoreField>{score}</S.EventScoreField>
                        <S.EventStatusField className={`${transactionDetailClass}`}>{transactionDetailTranslation}</S.EventStatusField>

                    </S.BetSlipDetailEvent>
                )
            }))}
        </S.BetSlipDetailsListWrapper>
    );
};

const getTransactionStatus = (statusCode, returnClass) => {
    let resultText = '';

    switch (statusCode) {
        case 0:
            resultText = 'pending';
            break;
        case 1:
            resultText = 'placed';
            break;
        case 2:
            resultText = 'won';
            break;
        case 3:
            resultText = 'lost';
            break;
        case 4:
            resultText = 'cancel';
            break;
        case 5:
            resultText = 'cashout';
            break;
        default:
            resultText = 'default';
            break;
    }

    if (returnClass) {
        return resultText;
    } else {
        return `betSlipDetails_${resultText}`;
    }
};

const BetSlipDetails = ({
    isPending,
    events,
    error,
    isBetSlipDetailsOpen,
    getBetSlipCheckResults,
    clearBetSlipCheckResults,
    toggleBetSlipDetailsModal,
    transactionId,
}) => {

    const { transactionDetails, stake, odds, possibleReturn, confirmedReturn, slipType, regDate, statusCode } = events;
    const [betSlipId, setBetSlipId] = useState(transactionId);

    const currencyCode = process.env.MAIN_CURRENCY_CODE;
    const betSlipStatus = getTransactionStatus(statusCode);
    

    const parseSlipType = (slipType) => {
        return betSlipTypes.getByType(slipType).name;
    };

    

    const handleBetSlipCheckInputChange = (event) => {
        const adjustedBetSlipId = event.target.value.replace(/\D/, '');
        setBetSlipId(adjustedBetSlipId);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        clearBetSlipCheckResults();
        getBetSlipCheckResults(betSlipId);
    };

    return (

        <S.BetSlipDetailsWrapper>

            <S.BetSlipCheckContent>
                <S.FormGroupWrapper
                    as={Box}
                    alignItems="center"
                    flexDirection="row"
                >
                    <S.Label>{translation('betSlipDetails_label')}</S.Label>

                    <S.Input
                        autocomplete="off"
                        autocorrect="off"
                        placeholder={translation('betSlipDetails_placeholder')}
                        autocapitalize="off"
                        spellcheck="false"
                        value={betSlipId}
                        onChange={handleBetSlipCheckInputChange}
                    />
                    <S.Button onClick={handleSubmit}>{translation('betSlipDetails_submit')}</S.Button>
                </S.FormGroupWrapper>
            </S.BetSlipCheckContent>

            { isPending ?
                <Loader
                    color={theme.$loaderColor}
                />
            : (!_isEmpty(events) ? (
                <>
                    <S.BetSlipInformationWrapper
                        as={Box}
                        alignItems="center"
                        flexDirection="row"
                    >
                        {renderInformationData('2.5', 'date', `${formatDate(regDate, 'dd-MM-yyyy')} ${formatDate(regDate, 'HH:mm')}`)}
                        {renderInformationData('2', 'betNumber',  transactionId )}
                        {renderInformationData('2', 'stake', `${stake} ${currencyCode}`)}
                        {renderInformationData('2', 'possibleWin', `${possibleReturn} ${currencyCode}`)}
                        {renderInformationData('2', 'wonAmount', `${confirmedReturn} ${currencyCode}`)}
                        {renderInformationData('2', 'type', translation(parseSlipType(slipType)))}
                        {odds ? renderInformationData('1', 'odds', odds) : ''}

                    </S.BetSlipInformationWrapper>

                        { transactionDetails ? renderBetSlipDetailsList(transactionDetails) : '' }

                    <S.BetSlipDetailsStatusWrapper
                        as={Box}
                        alignItems="center"
                        flexDirection="row"
                    >
                        <S.BetSlipDetailsStatus>{betSlipStatus}</S.BetSlipDetailsStatus>
                    </S.BetSlipDetailsStatusWrapper>
                </>

                ) : <S.BetSlipDetailsNoResult>{translation('betSlipDetails_noResult')}</S.BetSlipDetailsNoResult>
            )}

            {error && <S.Error>{error}</S.Error>}

        </S.BetSlipDetailsWrapper>
    );
};

const mapStateToProps = ({ BetSlipCheck: { isPending, events, error, isBetSlipDetailsOpen } }) => {
    return {
        isPending,
        events,
        error,
        isBetSlipDetailsOpen,
    };
};

const mapDispatchToProps = {
    getBetSlipCheckResults,
    clearBetSlipCheckResults,
    toggleBetSlipDetailsModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BetSlipDetails);
